
import React from 'react';
import { DialogContent } from "@/components/ui/dialog";
import { ReportForm } from "@/components/ReportForm/ReportForm";
import { ReportFormData } from "@/components/ReportForm/formSchema";
import { Download } from "lucide-react";

export const getReportDialogContent = (
  isSuccess: boolean, 
  onSubmit: (data: ReportFormData) => void, 
  isLoading: boolean,
  pdfPath?: string
) => (
  <DialogContent className="sm:max-w-md md:max-w-lg">
    {isSuccess ? (
      <div className="py-10 text-center space-y-4">
        <h2 className="text-2xl font-bold text-primary">Thank You!</h2>
        <p className="text-lg">Your report will be sent to your email shortly.</p>
        {pdfPath && (
          <div className="mt-6">
            <a 
              href={pdfPath} 
              download
              className="inline-flex items-center gap-2 bg-primary text-white px-6 py-2 rounded-md hover:bg-primary/90"
            >
              <Download size={18} />
              Download PDF Now
            </a>
          </div>
        )}
      </div>
    ) : (
      <ReportForm onSubmit={onSubmit} isSubmitting={isLoading} />
    )}
  </DialogContent>
);

export default getReportDialogContent;
